import { HttpClient } from '@shared/adapters/HttpClient';

export interface ProductLocation {
    id: number;
    code: string;
    stock: number;
}

export interface ProductLocationsApiResponse {
    data: ProductLocation[];
    meta?: { total: number; perPage: number; currentPage: number; lastPage: number };
}

export class ProductLocationsApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getProductLocations(productIds: number[]): Promise<ProductLocation[]> {
        if (productIds.length === 0) return [];
        const productIdsString = productIds.join(',');
        const response = await this.httpClient.get<{ data: ProductLocation[] } | ProductLocationsApiResponse>(
            `/locations?product_ids=${productIdsString}`
        );
        const raw = (response as any)?.data;
        const list = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
        return list.map((loc: any) => ({
            id: loc.id,
            code: loc.code ?? '',
            stock: loc.stock ?? 0,
        }));
    }
}
